import { BaseEditor, IBaseEditorProps } from "./BaseEditor";
import * as React from "react";
import { ICheckboxSpecificProps, Checkbox } from "./Checkbox";
import { LabelPosition } from "./LabelPosition";
import * as classNames from "classNames";
import { isNotEmpty } from "./Validation/RawValueRules";
import { Guid } from "../Utils/Guid";

export interface ICheckboxEditorProps extends IBaseEditorProps, ICheckboxSpecificProps, React.Props<CheckboxEditor> {
    labelPosition?: LabelPosition;
    linkLabel?: string;
}

export class CheckboxEditor extends BaseEditor<ICheckboxEditorProps> {
    constructor(props: ICheckboxEditorProps) {
        super(props);
    }

    public render(): JSX.Element {
        const wrapperCss = classNames("form-group", this.props.cssWrapper, {
            error: this.state.typingFinished && !this.state.isValid && !this.state.isValidOutside,
            valid: this.state.typingFinished && this.state.isValid && this.state.isValidOutside,
        });

        const isLabelOnLeft = this.props.labelPosition !== null && this.props.labelPosition === LabelPosition.Left;

        return (
            <div className={wrapperCss} ref={(elem: HTMLElement) => (this.wrapperRef = elem)}>
                <label className="controls-checkbox">
                    {isLabelOnLeft ? this.getLabel() : null}
                    {this.getInput()}
                    {isLabelOnLeft ? null : this.getLabel()}
                    {this.getTooltip()}
                    {this.getValidationErrorsContainer()}
                </label>
            </div>
        );
    }

    public componentDidMount(): void {
        this.bindLabelToInput();
        this.setState({ typingFinished: true });
    }

    private getInput(): JSX.Element {
        return (
            <Checkbox
                {...(this.props as any)}
                id={this.state.inputGroupId}
                onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                    this.handleValidationResultChange(isValid, errors, showValidationMessages)
                }
            />
        );
    }

    private getLabel(): JSX.Element {
        if (!this.props.label) {
            return null;
        }

        return (
            <span className={`label${this.props.labelGridClasses ? ` ${this.props.labelGridClasses}` : ""}`}>
                {this.props.label}
            </span>
        );
    }

    private bindLabelToInput(): void {
        let propId: string = null;
        if (this.props.hasOwnProperty("id")) {
            propId = this.props.id;
        }

        const id = isNotEmpty(propId) ? propId : Guid.getNext();
        this.setState({ inputGroupId: id });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
